// /docs landing — tile grid linking to every section. The first place a
// non-engineer arriving here should be able to find their topic in one scan.

import { Link } from "react-router-dom";
import { DOC_SECTIONS } from "./DocsLayout";

export function DocsIndex() {
  return (
    <div style={{ maxWidth: 1080, margin: "0 auto", padding: "64px 32px 96px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 40 }}>
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 11,
            letterSpacing: "0.12em",
            color: "var(--accent-fg)",
            textTransform: "uppercase",
          }}
        >
          MCPBuild Docs
        </span>
        <h1
          style={{
            margin: 0,
            fontFamily: "var(--font-sans)",
            fontSize: 44,
            lineHeight: "48px",
            fontWeight: 600,
            letterSpacing: "-0.025em",
            color: "var(--fg-1)",
            maxWidth: 720,
          }}
        >
          Build connectable, demoable tools the AI writes for you.
        </h1>
        <p
          style={{
            margin: 0,
            fontFamily: "var(--font-sans)",
            fontSize: 17,
            lineHeight: "26px",
            color: "var(--fg-2)",
            maxWidth: 640,
          }}
        >
          Written for non-engineers. Every guide has copy-paste prompts and
          end-to-end examples. If you're prototyping for a demo, start with{" "}
          <Link to="/docs/quickstart" style={{ color: "var(--accent-fg)" }}>
            Quickstart
          </Link>{" "}
          or{" "}
          <Link to="/docs/triggers" style={{ color: "var(--accent-fg)" }}>
            Trigger phrases
          </Link>
          .
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gap: 16,
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
        }}
      >
        {DOC_SECTIONS.map((s, i) => (
          <Link
            key={s.slug}
            to={`/docs/${s.slug}`}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              padding: "20px 22px",
              border: "1px solid var(--line-2)",
              borderRadius: 12,
              background: "var(--surface-1)",
              color: "var(--fg-1)",
              textDecoration: "none",
              transition: "border-color 120ms, transform 120ms",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "var(--accent-line)";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "var(--line-2)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <div
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: 11,
                letterSpacing: "0.08em",
                color: "var(--fg-4)",
                textTransform: "uppercase",
              }}
            >
              {String(i + 1).padStart(2, "0")} · Guide
            </div>
            <div
              style={{
                fontFamily: "var(--font-sans)",
                fontSize: 17,
                fontWeight: 600,
                color: "var(--fg-1)",
                lineHeight: "22px",
              }}
            >
              {s.label}
            </div>
            <div
              style={{
                fontFamily: "var(--font-sans)",
                fontSize: 13.5,
                lineHeight: "20px",
                color: "var(--fg-3)",
              }}
            >
              {s.blurb}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
